import { Sanitized } from '../../@types/sanitized';
import { Type } from 'class-transformer';

export class VideoImage implements Sanitized.VideoImage {
    boost_shopping_cart_id: string;
    image_source_low_resolution: string;
    image_source_high_resolution: string;
    image_source_trimmed?: string;
    @Type(() => Number)
    sort_order: number;
    image_caption?: string;
}
